import core from './core/index'
export default {
    namespaced: true,
    modules: {
        core
    }
}